var map = {
	"./account-icon-active.svg": "./src/assets/navigationdrawer-ax/account-icon-active.svg",
	"./account-icon.svg": "./src/assets/navigationdrawer-ax/account-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/navigationdrawer-ax sync recursive ^\\.\\/account\\-icon.*\\.svg$";